module.exports = __webpack_public_path__ + "img/特产店铺3.0becc5ce.png";